import { MediaLibraryConsts } from '@shared/MediaLibraryConsts';
import { MediaLibraryModel, MediaLibraryServiceProxy } from '@shared/service-proxies/service-proxies';
import {
    Component,
    ElementRef,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    OnInit,
    Output,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { FileSaverService } from 'ngx-filesaver';
import { PreviewButtonTypes } from '@shared/AppEnums';
@Component({
    selector: 'AttachementViewer',
    templateUrl: './AttachementViewer.component.html',
    styleUrls: ['./AttachementViewer.component.scss'],
})
export class AttachementViewerComponent extends AppComponentBase implements OnInit, OnChanges {
    @Input() ShowPreviewMedia: boolean = true;
    @Input() ShowDownloadLinkButton: boolean = false;
    @Input() PreviewButtonType: PreviewButtonTypes = PreviewButtonTypes.Button;
    @Input() Attachement: MediaLibraryModel;
    @Input() height: string = '400px';
    @Input() width: string = '100%';
    @Input() ShowRemoveButton: boolean = false;
    @Input() ShowFileInfo: boolean = true;
    @Input() RemoveAttachementLabel: string = this.l('RemoveAttachement');
    @Output() OnRemoveAttachement = new EventEmitter();
    filesize: string;
    CDR: ChangeDetectorRef;
    isloading: boolean = true;

    constructor(injector: Injector, private _FileSaverService: FileSaverService, private _cdr: ChangeDetectorRef) {
        super(injector);
        this.CDR = _cdr;
    }

    ngOnInit() {
        if (this.Attachement != undefined) {
            this.filesize = MediaLibraryConsts.SizeSuffix(this.Attachement.fileSize);
        }
        this.CDR.detectChanges();
    }
    ngOnChanges() {
        if (this.Attachement && this.Attachement.fileToken && this.Attachement != undefined) {
            this.filesize = MediaLibraryConsts.SizeSuffix(this.Attachement.fileSize);
            if (this.Attachement.fileMimeType.includes('application')) {
                this.height = '50px';
                this.isloading = false;
            }
            if (this.ShowPreviewMedia == false) {
                this.height = '50px';
                this.isloading = false;
            }
        } else {
            this.isloading = false;
        }
    }
    showfile() {
        console.log(this.Attachement);

        // let blob = new Blob(
        //     [this.Attachement.fileContent.replace('data:' + this.Attachement.fileMimeType + ';base64,', '')],
        //     { type: this.Attachement.fileMimeType }
        // );
        // let url = window.URL.createObjectURL(blob);

        const base64 = this.Attachement.fileContent.split(',')[1]; // الجزء اللي بعد base64,

        const blob = this.b64toBlob(base64, this.Attachement.fileMimeType);
        const url = URL.createObjectURL(blob);

        if (this.Attachement.fileMimeType === 'application/pdf') {
            window.open(url, '_blank');
            // let win = window.open(url, '_blank');
            // win.document.write(
            //     '<iframe title="' +
            //         this.Attachement.fileName +
            //         '" src="' +
            //         this.Attachement.fileContent +
            //         '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            // );
        } else {
            window.open(url, this.Attachement.fileName);
        }
    }

    b64toBlob(b64Data: string, contentType: string = ''): Blob {
        const byteCharacters = atob(b64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

    RemoveAttachment() {
        this.OnRemoveAttachement.emit();
    }
    DownloadFile() {
        let blob = new Blob(
            [
                MediaLibraryConsts.b64toBlob(
                    this.Attachement.fileContent.replace('data:' + this.Attachement.fileMimeType + ';base64,', ''),
                    this.Attachement.fileMimeType
                ),
            ],
            { type: this.Attachement.fileMimeType }
        );
        this._FileSaverService.save(blob, this.Attachement.fileName, this.Attachement.fileMimeType);
    }
    showloading() {
        this.isloading = false;
        //this.CDR.reattach();
    }
}
